import { showOrderModal } from './modal';
export { clone, killClone, cleanClone };

function clone(currentEventTarget, currentEventDataset) {
	var orderModalMain = document.querySelector(".orderModalClone");
	var orderModalClone = orderModalMain.cloneNode(true);
	var totalPrice = 0.00;
	orderModalClone.classList.remove("orderModalClone");
	orderModalClone.classList.remove("hide-important");
	orderModalClone.classList.add("orderModal");
	document.querySelector("#orderModal").appendChild(orderModalClone);
	console.log("Clone created");
	showOrderModal(currentEventTarget, currentEventDataset, totalPrice);
}

function killClone() {
	var orderModalClone = document.querySelector(".orderModal");
	var cleanModalClone = document.querySelector(".cleanModal");

	if (orderModalClone) {
		orderModalClone.parentNode.removeChild(orderModalClone);
		sessionStorage.clear();
		console.log("Clone killed 💀, Order 66 canceled 📃, Storage cleared 🧹");
	} else if (cleanModalClone) {
		cleanModalClone.parentNode.removeChild(cleanModalClone);
		sessionStorage.clear();
		console.log("Clone killed 💀, Order 66 canceled 📃, Storage cleared 🧹");
	} else {
		console.log('not a single clone found');
	}
}

function cleanClone() {
	var cleanMain = document.querySelector(".cleanModalClone");
	var cleanClone = cleanMain.cloneNode(true);
	var overlay = document.querySelector("#cleanModal");
	cleanClone.classList.remove("cleanModalClone");
	cleanClone.classList.remove("hide-important");
	cleanClone.classList.add("cleanModal");
	overlay.appendChild(cleanClone);
	overlay.style.display = "flex";
	console.log("Clean Clone created");
}